import { Dispatch, ThunkAction } from '../../../types/actions';
import { IGetState } from '../../../types/types';
import { IAuthUser } from '../../../store/model/authUser/types';
import { authUserPatch } from './api/helper/authUserPatch';

export const authUserSetHideDoneChecklistItems = (
    userId: string,
    isHideDoneChecklistItems: boolean
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const userPatch: IAuthUser = {
            id: userId,
            meta: {
                isHideDoneChecklistItems
            }
        };
        return dispatch(authUserPatch(userPatch));
    };
    return action;
};
